<template>
  <div id="profileWrap">
    <div class="panel"><img :src="imgsrc" alt=""></div>
    <div class="frame-outer" :style="frameStyle">
      <div class="inr" @click.stop="onClick('profile')">問題に進む</div>
      <div class="arrow" :style="arrowStyle"></div>
    </div>
  </div>
</template>

<script>
  import _$ from 'jquery'
  // import _ from 'lodash'

  export default {
    name: 'Profile',
    props: {
    },
    data() {
      return {
        // publicPath: process.env.BASE_URL,
        frameStyle: {
          backgroundImage: 'url(./img/common/pink_frm02_522_t.png),url(./img/common/pink_frm02_522_b.png), url(./img/common/pink_frm02_l.png), url(./img/common/pink_frm02_r.png)'
        },
        arrowStyle: {
          backgroundImage: 'url(./img/common/white_arw.png)'
        },
        imgsrc: null,
        timer: null
      }
    },
    mounted(){
      this.imgsrc = this.$parent.imgSrc,
      this.blinkArrow()
    },
    destroyed() {
      this.stopTimer()
    },
    watch: {
    },
    methods: {
      onClick: function(val){
        this.$emit('selectOpening', val);
      },
      blinkArrow: function(){
        this.timer = setInterval(function(){
          _$('#profileWrap .arrow').toggle()
        }.bind(this), 500)
      },
      stopTimer: function(){
        clearInterval(this.timer)
      }
    }
  }
</script>

<style lang="scss" scoped>
  #profileWrap {
    width: 100%;
    height: 100%;

    .panel {
      height: calc(100% - 19.466vw);

      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }

    .frame-outer {
      background-position: left top, left bottom, left top, right top;
      background-repeat: no-repeat, no-repeat, repeat-y, repeat-y;
      background-size: toVW(522) auto, toVW(522) auto, toVW(15) auto, toVW(15) auto;
      width: toVW(522);
      height: toVW(120);
      margin: toVW(13) auto;
      position: relative;

      .inr {
        width: 100%;
        height: 100%;
        padding: toVW(40);
        text-align: center;
        line-height: 1.5;
        letter-spacing: .07em;
      }

      .arrow {
        background-repeat: no-repeat;
        background-size: contain;
        width: toVW(21);
        height: toVW(28);
        position: absolute;
        top: calc((100% - 3.733vw) / 2);
        left: toVW(37);
        display: none;
      }
    }
  }
</style>
